import { render } from "./ListCard.vue?vue&type=template&id=508d6b02"
import script from "./ListCard.vue?vue&type=script&lang=js"
export * from "./ListCard.vue?vue&type=script&lang=js"

import "./ListCard.vue?vue&type=style&index=0&id=508d6b02&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__